// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__uToF2","loading-wheel":"styles_loading-wheel__9zU9i"};